<template>
  <div>

    <Head :title="`${book.data.title}`" />
    <div class="flex justify-start mb-8 max-w-3xl">
      <h1 class="text-3xl font-bold">
        <Link class="text-accent-primary-text" href="/books">Boeken</Link>
        <span class="text-accent-primary-text font-medium">/</span>
        {{ book.data.title }}
      </h1>
      <img v-if="book.data.cover" class="block ml-4 w-8 h-8 rounded-full" :src="book.data.cover" />
    </div>

    <div class="flex flex-wrap">
      <div class="w-full">
        <ul class="flex mb-0 list-none flex-wrap pt-3 pb-4 flex-row">
          <li class="-mb-px mr-2 last:mr-0 flex-auto text-center">
            <a class="text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal cursor-pointer"
              v-on:click="toggleTabs('details')"
              v-bind:class="{'text-accent-primary-text bg-white': openTab !== 'details', 'text-accent-primary-text bg-accent-primary': openTab === 'details'}">
              Details
            </a>
          </li>

          <li class="-mb-px mr-2 last:mr-0 flex-auto text-center">
            <a class="text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal cursor-pointer"
              v-on:click="toggleTabs('new')"
              v-bind:class="{'text-accent-primary-text bg-white': openTab !== 'new', 'text-accent-primary-text bg-accent-primary': openTab === 'new'}">
              +
            </a>
          </li>

          <li class="-mb-px mr-2 last:mr-0 flex-auto text-center" v-for="(bookItem, index) in book.data.book_items.data"
            :key="'bookItemTab' + index">
            <a class="text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal cursor-pointer"
              v-on:click="toggleTabs(bookItem.serial)"
              v-bind:class="{'text-accent-primary-text bg-white': openTab !== bookItem.serial, 'text-accent-primary-text bg-accent-primary': openTab === bookItem.serial}">
              Barcode: {{bookItem.serial}}
            </a>
          </li>

          <!-- <li class="-mb-px mr-2 last:mr-0 flex-auto text-center">
            <a class="text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal cursor-pointer" v-on:click="toggleTabs('ratings')" v-bind:class="{'text-accent-primary-text bg-white': openTab !== 'ratings', 'text-accent-primary-text bg-accent-primary': openTab === 'ratings'}">
              Ratings
            </a>
          </li> -->
        </ul>
        <div class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
          <div class="px-4 py-5 flex-auto">
            <div class="tab-content tab-space">
              <div v-bind:class="{'hidden': openTab !== 'details', 'block': openTab === 'details'}">
                <edit-tab :genres="genres" :categories="categories" :authors="authors" :book="book" />
              </div>

              <div v-bind:class="{'hidden': openTab !== 'new', 'block': openTab === 'new'}">
                <new-tab :book="book" />
              </div>

              <div v-for="(bookItem, index) in book.data.book_items.data" :key="'bookItemTabContent' + index"
                v-bind:class="{'hidden': openTab !== bookItem.serial, 'block': openTab === bookItem.serial}">
                <queue-tab :bookItem="bookItem" :order="order" :direction="direction" />
              </div>
              <!-- <div v-bind:class="{'hidden': openTab !== 'ratings', 'block': openTab === 'ratings'}">
                <p>
                  Efficiently unleash cross-media information without
                  cross-media value. Quickly maximize timely deliverables for
                  real-time schemas.
                  <br />
                  <br />
                  Dramatically maintain clicks-and-mortar solutions
                  without functional solutions.
                </p>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import EditTab from './EditTab.vue'
import NewTab from './NewTab.vue'
import QueueTab from './QueueTab.vue'
// import TextInput from '@/Shared/TextInput'
// import FileInput from '@/Shared/FileInput'
// import SelectInput from '@/Shared/SelectInput'
// import LoadingButton from '@/Shared/LoadingButton'
// import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  components: {
    // FileInput,
    Head,
    Link,
    EditTab,
    NewTab,
    QueueTab
    // LoadingButton,
    // SelectInput,
    // TextInput,
    // TrashedMessage,
  },
  layout: Layout,
  props: {
    book: Object,
    genres: Array,
    categories: Array,    
    authors: Array,
    order: String,
    direction: String
  },

  data() {
    return {
      openTab: 'details'
    }
  },

  mounted() {
    let params = new URLSearchParams(window.location.search);
    this.openTab = params.get('activeTab') ?? 'details'
  },

  methods: {
    toggleTabs: function(tabName){
      this.openTab = tabName
    }   
  },
}
</script>
